import useSWR, { BareFetcher, SWRConfiguration, useSWRConfig } from 'swr';
type RequestFunction<T, U> = (params: T) => Promise<U>;

export const useCache = <T, U>(
  requestFunction: RequestFunction<T, U>,
  params: T | null,
  config?: SWRConfiguration<U, any, BareFetcher<U>>,
) => {
  const { mutate } = useSWRConfig();

  const id = params ? [requestFunction.name, ...Object.values(params)] : null;
  const fetcher = async () => requestFunction(params!);

  const { data, error, isValidating: loading } = useSWR<U>(id, id ? fetcher : null, config);

  const revalidate = async () => {
    if (id) {
      await mutate(id);
    }
  };

  const resetCache = async (value?: unknown) => {
    if (id) mutate(id, value ?? undefined, false);
  };

  return { data, loading, error, revalidate, resetCache };
};
